import { Badge } from '@/components/ui';
import { categoryTheme } from '@/lib/categoryTheme';

/**
 * CategoriaBadge — pill que muestra la "Categoría FC" del usuario (su
 * nivel de fidelidad en el sistema First Class). ROUND14 introdujo el
 * componente; ROUND15 #6 lo migró al theme centralizado `categoryTheme`
 * para que el color del pill varíe por categoría (Bronce ámbar, Oro
 * dorado, etc.) en vez de un gold único.
 *
 * El backend conserva el nombre `user_profiles.tier` (admin/web/app
 * comparten esa columna). Este componente es el wrapper de presentación:
 * lee el valor crudo y muestra label + color via `categoryTheme(slug)`.
 */
export function CategoriaBadge({
  value,
  className = '',
}: {
  /** Valor crudo del backend (`user_profiles.tier`): 'bronze' / 'silver' / etc. */
  value: string | null | undefined;
  className?: string;
}): JSX.Element | null {
  if (!value || !value.trim()) return null;
  const { label, tone } = categoryTheme(value);
  return (
    <Badge tone={tone} className={className}>
      {label}
    </Badge>
  );
}
